// extracted by mini-css-extract-plugin
export var productBannerTop = "SecondaryNav-module--productBannerTop--fc485";